import { Injector, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { CloseAllModalsEvent } from '../../shared/events/close-all-modals-event';
import {MessagingService} from "../../shared/events/messaging-service";

export abstract class ModalBaseComponent implements OnDestroy {

  protected messagingService: MessagingService;
  private closeAllModalsEventSubscription: Subscription;

  constructor( inject: Injector ) {
    this.messagingService = inject.get( MessagingService );
    this.closeAllModalsEventSubscription = this.messagingService.of( CloseAllModalsEvent ).subscribe( message => {
      this.closeModal();
    } );
  }

  abstract closeModal();

  ngOnDestroy() {
    this.closeAllModalsEventSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/modal-base-component.ts